export default __webpack_public_path__ + "static/media/logo-dark.b7d1dd0d.png";